import styled from '@emotion/styled';

const Dropdown = styled.ul`

background-color: #ffffff;
  display: inline-block;
  padding: 0;
  height: 40px;
  overflow: hidden;
  transition: all .3s ease;
  vertical-align: top;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 150px;

  &:hover {
    height: 80px;
  }
`;

export default Dropdown;
